<template>
    <b-modal id="exportHistoryModal" :title="modalTitle" size="lg" hide-footer no-fade @show="onShow">
        <ExportHistoryList v-if="scheduleId" ref="historyList" :schedule-id="scheduleId" :limit="20" />
    </b-modal>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import ExportHistoryList from "./ExportHistoryList.vue";

@Component({
    components: {
        ExportHistoryList
    }
})
export default class ExportHistoryModal extends Vue {
    @Prop({ required: true }) scheduleId!: number;
    @Prop({ default: "" }) scheduleName!: string;

    get modalTitle(): string {
        return this.scheduleName ? `History: ${this.scheduleName}` : "Export History";
    }

    private onShow() {
        this.$nextTick(() => {
            const historyList = this.$refs.historyList as any;
            if (historyList?.loadHistory) {
                historyList.loadHistory();
            }
        });
    }
}
</script>
